// src/types/error.d.ts
export type ErrorCategory = 'Authentication' | 'Network' | 'API' | 'Validation' | 'BusinessLogic' | 'Unknown';

export interface StructuredError {
  what: string;       // Concise description of what failed (e.g., "Simulation Failed", "Failed to upload rides")
  why: string;        // Explanation of why it failed (e.g., "Invalid input data", "API returned 401 Unauthorized", "No vehicles with standard seats")
  howToFix?: string;  // Actionable advice on how to fix it (e.g., "Please check your network connection", "Ensure your fleet has standard seats")
  details?: any;      // Optional: raw error object or additional technical details
  category: ErrorCategory; // Categorize the error for easier filtering/handling
}

// Custom Error Class
export class AppError extends Error {
  structuredError: StructuredError;

  constructor(structuredError: StructuredError) {
    // Call the base Error constructor with a concise message
    super(structuredError.what + (structuredError.why ? `: ${structuredError.why}` : ''));
    this.name = 'AppError';
    this.structuredError = structuredError;
    // Set the prototype explicitly to ensure `instanceof AppError` works correctly
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
